export default __webpack_public_path__ + "static/ventajas-01-7e3b388dedc26e4b0a407f62f200203c.svg";